(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'react-icons/fa6', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-icons/fa6'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.fa6, global.propTypes);
    global.LearnMore = mod.exports;
  }
})(this, function (exports, _react, _fa, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var LearnMore = function (_React$Component) {
    _inherits(LearnMore, _React$Component);

    function LearnMore() {
      _classCallCheck(this, LearnMore);

      return _possibleConstructorReturn(this, (LearnMore.__proto__ || Object.getPrototypeOf(LearnMore)).apply(this, arguments));
    }

    _createClass(LearnMore, [{
      key: 'renderImg',
      value: function renderImg() {
        // Don't render the image if there is no src
        if (!this.props.logoSrc) {
          return false;
        }

        return _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('img', {
            style: {
              height: '20px',
              marginTop: '-8px'
            },
            className: 'sap-logo',
            alt: this.props.logoAlt || '',
            src: encodeURI(this.props.logoSrc)
          })
        );
      }
    }, {
      key: 'renderLink',
      value: function renderLink() {
        // Don't render link without text and an href
        if (!this.props.learnHref || !this.props.learnText) {
          return false;
        }

        return _react2.default.createElement(
          'a',
          {
            href: encodeURI(this.props.learnHref)
          },
          this.props.learnText,
          _react2.default.createElement(_fa.FaAngleRight, null)
        );
      }
    }, {
      key: 'render',
      value: function render() {
        if (!this.props.learnHref || !this.props.learnText || !this.props.text) {
          return false;
        }
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            {
              className: 'footer-learn-more',
              style: this.props.textStyles ? this.props.textStyles : {}
            },
            this.renderImg(),
            _react2.default.createElement(
              'span',
              {
                style: {
                  color: '#fff',
                  fontWeight: '300',
                  padding: '0 7px 0 2px'
                },
                className: 'sap-text'
              },
              this.props.text
            ),
            this.renderLink()
          )
        );
      }
    }]);

    return LearnMore;
  }(_react2.default.Component);

  exports.default = LearnMore;
  ;

  LearnMore.propTypes = {
    logoAlt: _propTypes2.default.string,
    logoSrc: _propTypes2.default.string,
    text: _propTypes2.default.string,
    learnHref: _propTypes2.default.string,
    learnText: _propTypes2.default.string,
    textStyles: _propTypes2.default.object
  };
});